module.exports = __webpack_public_path__ + "static/media/A1-30-Krolgzer-cod138.5892d23d.png";